module.exports = __webpack_public_path__ + "fonts/400-italic-greek.5a8388b.woff2";